import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getFavoritos,
  postAgregarFavoritos,
  postEliminarFavoritos,
} from "../../actions/favoritos";
import CardProduct from "../products/cardProduct";
import Dolar from "../../common/dolar";
import colores from "../../shared/constants/styles";
import LoadingCart from "../ShoppingCart/LoadingCart";
import { Container, IconButton, Tooltip, Typography } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import StarBorderIcon from "@mui/icons-material/StarBorder";

interface LocalSession {
  clienteId: string;
  contactoId: number;
  tipoRol: number;
}

interface Producto {
  id: string;
  descripcion: string;
  image?: string;
  precio?: number;
  moneda?: { simbolo: string };
  gruposDesc?: string;
}

const Favoritos = () => {
  const dispatch = useDispatch();
  const [favoritosLocales, setFavoritosLocales] = useState<Set<string>>(
    new Set(),
  );

  const localSession = window.localStorage.getItem("LocalSession");
  const localStorage: LocalSession | null = localSession
    ? JSON.parse(localSession)
    : null;

  const selectedClientRaw = window.localStorage.getItem("selectedClient");
  const selectedClient = selectedClientRaw
    ? JSON.parse(selectedClientRaw)
    : null;

  const { productosFavoritos, loading } = useSelector(
    (state: any) => state.favoritos,
  );
  const lista: Producto[] =
    productosFavoritos?.data?.$values ?? productosFavoritos?.data ?? [];

  // Sincronizar Set local cuando llegan del store
  useEffect(() => {
    if (lista.length > 0) {
      setFavoritosLocales(new Set(lista.map((f) => f.id)));
    }
  }, [productosFavoritos]);

  // Cargar favoritos al montar
  useEffect(() => {
    if (localStorage?.clienteId && localStorage?.contactoId) {
      dispatch(
        getFavoritos(localStorage.clienteId.trim(), localStorage.contactoId),
      );
    }
  }, []);

  const esFavorito = (productoId: string) => favoritosLocales.has(productoId);

  const handleToggleFavorito = (e: React.MouseEvent, productoId: string) => {
    e.stopPropagation();
    const clienteId = selectedClient?.[0]?.id ?? localStorage?.clienteId;

    const request = {
      clienteId,
      contactoid: localStorage?.contactoId,
      productoId,
    };

    if (esFavorito(productoId)) {
      setFavoritosLocales((prev) => {
        const next = new Set(prev);
        next.delete(productoId);
        return next;
      });
      dispatch(postEliminarFavoritos(request));
    } else {
      setFavoritosLocales((prev) => new Set(prev).add(productoId));
      dispatch(postAgregarFavoritos(request));
    }
  };

  return (
    <div style={{ backgroundColor: colores.grisClaro }}>
      <Dolar />

      {/* HEADER — mismo lineamiento que Productos */}
      <div
        className="container-fluid"
        style={{
          width: "100%",
          overflow: "hidden",
          clear: "both",
          marginBottom: "1.85rem",
        }}
      >
        <div className="d-flex justify-content-center">
          <hr style={{ width: "90%", color: "black", marginTop: "0" }} />
        </div>
        <Container
          maxWidth="xl"
          style={{ paddingRight: "60px", paddingLeft: "60px" }}
        >
          <div
            className="d-flex justify-content-between flex-wrap align-items-center"
            style={{ marginBottom: "0.600rem", paddingRight: "3.5rem" }}
          >
            <h1 className="fw-bolder" style={{ fontSize: "bolder" }}>
              MIS FAVORITOS
            </h1>
          </div>
        </Container>
      </div>

      {/* LISTADO */}
      <div
        className="container-fluid mx-0 px-0 w-100"
        style={{ margin: "2rem" }}
      >
        <div
          className="container-fluid"
          style={{
            backgroundColor: "white",
            width: "100%",
            overflow: "hidden",
            clear: "both",
            marginBottom: "1.85rem",
            paddingLeft: "76px",
            paddingRight: "76px",
          }}
        >
          <div
            className="d-flex justify-content-between"
            style={{ margin: "2rem 0", marginLeft: "3.7rem" }}
          >
            <h2>PRODUCTOS GUARDADOS</h2>
            {!loading && lista.length > 0 && (
              <Typography
                variant="body2"
                style={{ color: "#888", alignSelf: "center" }}
              >
                {lista.length} {lista.length === 1 ? "producto" : "productos"}
              </Typography>
            )}
          </div>

          <div
            className="container d-flex flex-row flex-wrap"
            style={{ marginBlock: "2rem", marginLeft: "3.7rem" }}
          >
            {/* Loading */}
            {loading && <LoadingCart />}

            {/* Lista vacía */}
            {!loading && lista.length === 0 && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "4rem 0",
                  color: "#aaa",
                  gap: "1rem",
                }}
              >
                <StarBorderIcon style={{ fontSize: "4rem", color: "#ddd" }} />
                <Typography variant="h6" style={{ color: "#bbb" }}>
                  Todavía no tenés productos favoritos
                </Typography>
                <Typography variant="body2" style={{ color: "#ccc" }}>
                  Explorá el catálogo y guardá los que más te interesen
                </Typography>
              </div>
            )}

            {/* Cards — mismo wrapper relativo que en Productos.jsx */}
            {!loading &&
              lista.map((producto) => (
                <div key={producto.id} style={{ position: "relative" }}>
                  <CardProduct data={producto} />

                  <Tooltip
                    title={
                      esFavorito(producto.id)
                        ? "Quitar de favoritos"
                        : "Agregar a favoritos"
                    }
                  >
                    <IconButton
                      onClick={(e) => handleToggleFavorito(e, producto.id)}
                      style={{
                        position: "absolute",
                        top: "12px",
                        right: "30px",
                        backgroundColor: "rgba(255,255,255,0.85)",
                        padding: "4px",
                      }}
                    >
                      {esFavorito(producto.id) ? (
                        <FavoriteIcon
                          fontSize="small"
                          style={{ color: "#c0392b" }}
                        />
                      ) : (
                        <FavoriteBorderIcon
                          fontSize="small"
                          style={{ color: "#c0392b" }}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Favoritos;
